module.exports = __webpack_public_path__ + "fonts/VetoSansCond-MediumItalic.2307e223.ttf";